import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useState } from "react";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DateObject from "react-date-object";
import { campaignFetcher, channelFetcher } from "../../api/requests";
import Cookies from "js-cookie";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useToaster } from "../../context/toaster";
import Container from "react-bootstrap/Container";
import ThinFooter from "../Footer/ThinFooter";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";

export default function CreateCampaign() {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState();

  const [channel, setChannel] = useState({
    banner: "",
    owner: 0,
    description: "",
    name: "",
    backgroundType: "image",
    backgroundImage: "",
    backgroundColor: "#ffffff",
    socials_address: [],
    confirm_to_channel: true,
    activation: true,
    published_date: new DateObject({
      calendar: persian,
      locale: persian_fa,
    }).format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
    Terms_participation_in_campaign: "",
    scoring_formula: "",
  });

  const [date, setDate] = useState(
    new DateObject({ calendar: persian, locale: persian_fa })
  );

  const user = Cookies.get("vaghfnamaUser");
  const parsedUser = JSON.parse(user ? user : "{}");
  const history = useHistory();
  const { addMessage } = useToaster();

  const handleChange = (name, value) => {
    setChannel((prev) => ({ ...prev, [name]: value }));
  };

  const showToast = (type, text) => {
    addMessage({
      id: Math.random().toString(36).substr(2, 9),
      type: type,
      text: text,
    });
  };

  const handleUpload = async () => {
    const formData = new FormData();
    formData.append("banner", channel.banner);
    formData.append("name", channel.name);
    formData.append("owner", parsedUser.user_id);
    formData.append("description", channel.description);
    formData.append("scoring_formula", channel.scoring_formula);
    formData.append(
      "Terms_participation_in_campaign",
      channel.Terms_participation_in_campaign
    );
    formData.append("confirm_to_channel", true);
    formData.append("activation", true);
    formData.append("published_date", channel.published_date);

    formData.append("background", channel.backgroundImage);
    formData.append("background_color", channel.backgroundColor);

    try {
      setLoading(true);
      const res = await campaignFetcher.post(formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (res) {
        setLoading(false);
        history.push("/account");
        showToast("success", "پویش با موفقیت ساخته شد.");
      }
    } catch (error) {
      setLoading(false);
      showToast(
        "error",
        error.response?.data?.detail ?? "خطایی رخ داده است، دوباره تلاش کنید."
      );
      console.error("Upload error:", error.response?.data);
    }
  };

  const handleDateChange = (value) => {
    setDate(value.toString().replace(/\//g, "-"));
    setChannel({
      ...channel,
      published_date: value.toString().replace(/\//g, "-"),
    });
  };

  return (
    <ContentWrapper>
      <Container
        fluid
        className="upload-details text-right"
        style={{
          paddingLeft: "30px",
          paddingRight: "30px",
          minHeight: "calc(100vh - 123px)",
        }}
      >
        <div>
          <Row
            style={{ marginLeft: "0px", marginRight: "0px", padding: "15px" }}
          >
            <Col lg={12}>
              <div className="osahan-form">
                <Row>
                  <Col lg={12}>
                    <Form.Group controlId="campaign-name">
                      <Form.Label>نام پویش</Form.Label>
                      <Form.Control
                        onChange={(e) => handleChange("name", e.target.value)}
                        type="text"
                        placeholder="نام..."
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={12}>
                    <Form.Group controlId="campaign-description">
                      <Form.Label>درباره</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="توضیحات..."
                        onChange={(e) =>
                          handleChange("description", e.target.value)
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={12}>
                    <Form.Group controlId="Terms_participation_in_campaign">
                      <Form.Label>شعار پویش</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        onChange={(e) =>
                          handleChange(
                            "Terms_participation_in_campaign",
                            e.target.value
                          )
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col lg={12}>
                    <Form.Group controlId="scoring_formula">
                      <Form.Label>فرمول انتخاب برنده</Form.Label>
                      <Form.Control
                        as="textarea"
                        placeholder="لایک + ویو"
                        rows={3}
                        onChange={(e) =>
                          handleChange("scoring_formula", e.target.value)
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  {/* <Col lg={3}>
                    <Form.Group controlId="background-type">
                      <Form.Label>نوع پس‌زمینه</Form.Label>
                      <Form.Control
                        as="select"
                        value={channel.backgroundType}
                        onChange={(e) => {
                          setBackgroundType(e.target.value);
                          handleChange("backgroundType", e.target.value);
                        }}
                      >
                        <option value="image">تصویر</option>
                        <option value="color">رنگ</option>
                      </Form.Control>
                    </Form.Group>
                  </Col> */}

                  <Col
                    style={{
                      display: "flex",
                      alignContent: "center",
                      flexWrap: "wrap",
                    }}
                    lg={3}
                  >
                    <Form.Group controlId="background-image">
                      <Form.Label>پس‌زمینه (تصویر)</Form.Label>
                      <Form.Control
                        type="file"
                        accept="image/*"
                        onChange={(e) =>
                          handleChange("backgroundImage", e.target.files[0])
                        }
                        className="form-control-file"
                      />
                    </Form.Group>
                  </Col>
                  <Col
                    style={{
                      display: "flex",
                      alignContent: "center",
                      flexWrap: "wrap",
                    }}
                    lg={3}
                  >
                    <Form.Group controlId="background-color">
                      <Form.Label>پس‌زمینه (رنگ)</Form.Label>
                      <Form.Control
                        type="color"
                        value={channel.backgroundColor}
                        onChange={(e) =>
                          handleChange("backgroundColor", e.target.value)
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col lg={3}>
                    <Form.Group controlId="banner-upload">
                      <Form.Label>بنر</Form.Label>
                      <Form.Control
                        type="file"
                        accept="image/*"
                        onChange={(e) =>
                          handleChange("banner", e.target.files[0])
                        }
                        className="form-control-file"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col lg={4}>
                    <Form.Group controlId="published-date">
                      <Form.Label
                        style={{ marginLeft: "10px", marginTop: "20px" }}
                      >
                        تاریخ انتشار
                      </Form.Label>
                      <DatePicker
                        onChange={handleDateChange}
                        format="YYYY/MM/DD HH:mm:ss"
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </div>

              <div className="osahan-area text-center mt-3">
                <Button
                  variant="outline-primary"
                  onClick={handleUpload}
                  style={{
                    cursor: loading ? "wait" : "pointer",
                  }}
                >
                  {loading ? "لطفا منتظر بمانید..." : "ارسال"}
                </Button>
                {errors &&
                  Object.keys(errors).map(
                    (field) =>
                      errors[field].length > 0 && (
                        <p className="text-danger mt-2" key={field}>{`${
                          field.charAt(0).toUpperCase() + field.slice(1)
                        } ${errors[field][0]}`}</p>
                      )
                  )}
              </div>
            </Col>
          </Row>
        </div>
      </Container>

      <ThinFooter />
    </ContentWrapper>
  );
}
